<template>
  <div style="width:100%" class="d-flex flex-column flex-grow-1">
    <div class="d-flex align-center py-3">
      <div>
        <div class="display-1">Users</div>
        <v-breadcrumbs :items="breadcrumbs" class="pa-0 py-2"></v-breadcrumbs>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="isAdmin()"
        depressed
        color="primary"
        class="white--text"
        @click="inviteModal = true"
        >Invite User</v-btn
      >
    </div>

    <UserList
      v-if="!isLoading"
      :user-list="users"
      :is-loading="isLoading"
      @refresh="loadAdminUsers"
    />

    <AddEditUser
      v-if="addModal"
      :dialog="addModal"
      @refresh="loadAdminUsers"
      @close="addModal = false"
    />

    <InviteUser
      v-if="inviteModal"
      :dialog="inviteModal"
      type="admin"
      @close="inviteModal = false"
    />
  </div>
</template>

<script>
import UserList from "@/components/user/UserList";
import InviteUser from "@/components/user/InviteUser";
import AddEditUser from "@/components/user/AddEditUser";
export default {
  components: {
    InviteUser,
    UserList,
    AddEditUser
  },
  computed: {
    users() {
      return this.$store.getters["adminUser/getAdminUsers"];
    }
  },
  data() {
    return {
      isLoading: false,
      addModal: false,
      inviteModal: false,
      breadcrumbs: [
        {
          text: "Home",
          disabled: true
        },
        {
          text: "Users"
        }
      ]
    };
  },
  created() {
    this.loadAdminUsers();
  },
  methods: {
    async loadAdminUsers(payload = null) {
      this.addModal = false;
      this.isLoading = true;
      let loader = this.$loading.show();
      await this.$store
        .dispatch("adminUser/getAdminUsers", payload)
        .finally(() => {
          this.isLoading = false;
          loader.hide();
        });
    }
  }
};
</script>

<style>
.heading {
  font-size: 18pt;
  display: block;
}

.modal-lg {
  max-width: 1000px !important;
  width: 1000px !important;
}

.modal-dialog {
  max-width: 1000px !important;
  width: 1000px !important;
}
</style>
